var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{},[_c('div',{staticClass:"px-4 py-4"},[_c('h6',{staticClass:"text-h6 text-typo font-weight-bold"},[_vm._v("Сурлагын түвшин")]),_c('div',{staticClass:"chart pt-4"},[_c('canvas',{staticClass:"chart-canvas",attrs:{"id":"chart-cons-week","height":"170"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }